export const REQUESTED = 'RESET_PASSWORD_REQUESTED';
export const FAILED = 'RESET_PASSWORD_FAILED';
export const SUCCESSFUL = 'RESET_PASSWORD_SUCCESSFUL';
export const SETTINGS_SA_PROFILE_REQUESTED = 'SETTINGS_SA_PROFILE_REQUESTED';
export const SETTINGS_SA_PROFILE_FAILED = 'SETTINGS_SA_PROFILE_FAILED';
export const SETTINGS_SA_PROFILE_SUCCESSFUL = 'SETTINGS_SA_PROFILE_SUCCESSFUL';
export const UPDATE_SA_PROFILE_REQUESTED = 'UPDATE_SA_PROFILE_REQUESTED';
export const UPDATE_SA_PROFILE_FAILED = 'UPDATE_SA_PROFILE_FAILED';
export const UPDATE_SA_PROFILE_SUCCESSFUL = 'UPDATE_SA_PROFILE_SUCCESSFUL';
export const PAYMENT_HISTORY_REQUESTED = 'PAYMENT_HISTORY_REQUESTED';
export const PAYMENT_HISTORY_FAILED = 'PAYMENT_HISTORY_FAILED';
export const PAYMENT_HISTORY_SUCCESSFUL = 'PAYMENT_HISTORY_SUCCESSFUL';
export const SETTINGS_SEARCH_SCHOOLS = 'SETTINGS_SEARCH_SCHOOLS';



// WEBPACK FOOTER //
// ./src/containers/Settings/actionTypes.js